<template>
  <w-modal
    v-model="open"
    variant="normal"
    @close="close"
  >
    <template #header>
      <h1 class="sm:text-xl text-xl text-center">
        忘記密碼
      </h1>
    </template>
    <div>
      <h2 class="has-text-black is-size-5 pb-4">
        請填寫以下資訊，系統將通知管理員重設密碼。
      </h2>
      <w-input
        v-model.lazy="form.identification"
        :disabled="hasIdentificationParam"
        :message="getErrorMsgs('identification')"
        :show-error="hasErrorMsgs('identification')"
        :show-success="!forgetPwdValidator$.form.identification.invalid
          && forgetPwdValidator$.form.identification.$dirty"
        class="w-full"
        placeholder="統一編號"
        type="number"
        @blur="forgetPwdValidator$.form.identification.$touch()"
        @keydown="onNumberInputKeydown"
      />
      <w-input
        v-model.lazy="form.account"
        :message="getErrorMsgs('account')"
        :show-error="hasErrorMsgs('account')"
        :show-success="!forgetPwdValidator$.form.account.invalid
          && forgetPwdValidator$.form.account.$dirty"
        class="w-full"
        placeholder="帳號"
        type="text"
        @blur="forgetPwdValidator$.form.account.$touch()"
      />
    </div>
    <template #footer>
      <div class="flex items-center justify-end">
        <w-button
          :disabled="
            sending || (forgetPwdValidator$.form.$invalid && forgetPwdValidator$.form.$dirty)
          "
          :loading="sending"
          :variant="forgetPwdValidator$.form.$invalid ? 'outline' : null"
          class="sm:w-full"
          @click="send"
        >
          通知管理員
        </w-button>
      </div>
    </template>
  </w-modal>
</template>

<script>
import ForgetPassword from './ForgetPassword';

export default ForgetPassword;
</script>

<style lang="scss" scoped>
@import 'ForgetPassword';
</style>
